import React, { lazy, Suspense } from 'react';
import {Router, Switch, Route, Redirect} from 'react-router-dom';

import Loader from './components/common/Loader';
import ErrorBoundary from './components/common/ErrorBoundary';
import history from './services/history';
import routes from './constants/routes';
import PrivateRoute from './PrivateRoute';
import ProtectedRoute from './ProtectedRoute';

const Login = lazy(() => import('./components/Authentication/Login'));
const ForgotPassword = lazy(() => import('./components/Authentication/ForgotPassword'));
const ForgotPasswordEmailSent = lazy(() => import('./components/Authentication/ForgotPasswordEmailSent'));
const RestorePassword = lazy(() => import('./components/Authentication/RestorePassword'));
const TwoFactorAuth = lazy(() => import('./components/Authentication/TwoFactorAuth'));
const TwoFactorResent = lazy(() => import('./components/Authentication/TwoFactorAuth/TwoFactorResent'));
const ValidatePassword = lazy(() => import('./components/Authentication/ValidatePassword'));

const DashboardDay = lazy(() => import('./components/Day'));
const DashboardWeek = lazy(() => import('./components/Week'));
const DashboardMonth = lazy(() => import('./components/Month'));

const Configuration = lazy(() => import('./components/Configuration'));

const PushMessages = lazy(() => import('./components/PushMessages'));
const CouplingTable = lazy(() => import('./components/CouplingTable'));
const Chart = lazy(() => import('./components/Chart'));

const DonorsList = lazy(() => import('./components/DonorsList'));
const ChangePassword = lazy(() => import('./components/ChangePassword'));
const ChangePasswordTwoFactor = lazy(() => import('./components/ChangePassword/ChangePasswordTwoFactor'));
const ChangePasswordResent = lazy(() => import('./components/ChangePassword/ChangePasswordResent'));
const ChangeBloodbank = lazy(() => import('./components/ChangeBloodbank'));
const ChangePhone = lazy(() => import('./components/ChangePhone'));
const ChangePhoneTwoFactor = lazy(() => import('./components/ChangePhone/ChangePhoneTwoFactor'));
const ChangePhoneSuccess = lazy(() => import('./components/ChangePhone/ChangePhoneSuccess'));
const ChangePhoneResent = lazy(() => import('./components/ChangePhone/ChangePhoneResent'));

const MainRouter = () => (
    <Router history={history}>
        <ErrorBoundary>
        <Suspense fallback={<Loader className="is-fixed" />}>
        <Switch>
            <Route path={routes.LOGIN_ROUTE} component={Login}/>
            <Route path={routes.FORGOT_PASSWORD_ROUTE} component={ForgotPassword}/>
            <Route path={routes.FORGOT_PASSWORD_EMAIL_SENT_ROUTE} component={ForgotPasswordEmailSent}/>
            <Route path={routes.RESTORE_PASSWORD_ROUTE} component={RestorePassword}/>
            <Route path={routes.TWO_FACTOR_AUTH_ROUTE} component={TwoFactorAuth}/>
            <Route path={routes.TWO_FACTOR_AUTH_CODE_SENT_ROUTE} component={TwoFactorResent}/>
            <ProtectedRoute path={routes.VALIDATE_PASSWORD_ROUTE} component={ValidatePassword}/>
            <PrivateRoute path={`${routes.PUSH_MESSAGES_ROUTE}/:type`} component={PushMessages}/>
            <ProtectedRoute path={routes.CHART_ROUTE} component={Chart}/>
            <ProtectedRoute path={routes.COUPLING_TABLE_ROUTE} component={CouplingTable}/>
            <PrivateRoute path={`${routes.DASHBOARD_DAY_ROUTE}/:date`} component={DashboardDay}/>
            <PrivateRoute path={routes.DASHBOARD_WEEK_ROUTE} component={DashboardWeek}/>
            <PrivateRoute path={`${routes.DASHBOARD_MONTH_ROUTE}/:date`} component={DashboardMonth}/>
            <PrivateRoute path={routes.DONORS_LIST_ROUTE} component={DonorsList}/>
            <ProtectedRoute path={`${routes.CONFIGURATION_ROUTE}/:date`} component={Configuration}/>
            <PrivateRoute path={routes.CHANGE_BLOODBANK_ROUTE} component={ChangeBloodbank}/>
            <PrivateRoute path={routes.CHANGE_PASSWORD_ROUTE} component={ChangePassword}/>
            <PrivateRoute path={routes.CHANGE_PASSWORD_ENTER_CODE} component={ChangePasswordTwoFactor}/>
            <PrivateRoute path={routes.CHANGE_PASSWORD_CODE_RESENT_ROUTE} component={ChangePasswordResent}/>
            <PrivateRoute path={routes.CHANGE_PHONE_ROUTE} component={ChangePhone}/>
            <PrivateRoute path={routes.CHANGE_PHONE_ENTER_CODE} component={ChangePhoneTwoFactor}/>
            <PrivateRoute path={routes.CHANGE_PHONE_CODE_RESENT_ROUTE} component={ChangePhoneResent}/>
            <PrivateRoute path={routes.CHANGE_PHONE_SUCCESS_ROUTE} component={ChangePhoneSuccess}/>
            <PrivateRoute path={routes.INDEX} component={DashboardDay}/>
        </Switch>
        </Suspense>
        </ErrorBoundary>
    </Router>
);

export default MainRouter;
